import Component from '@glimmer/component';
import ContactModel from 'donor-elf-web/models/contact';
import MailchimpEmailSyncModel from 'donor-elf-web/models/mailchimp-email-sync';
import NewsletterContactModel from 'donor-elf-web/models/newsletter-contact';

interface ComponentArgs {
  contact: ContactModel;
  contactDetailRecordIsLoading: boolean;
  mailchimpEmailSyncs: MailchimpEmailSyncModel[];
  newsletterContact?: NewsletterContactModel;
  onUnhide: () => void;
  onNewsletterContactCreated: (
    newsletterContact: NewsletterContactModel,
  ) => void;
  onNewsletterContactDestroyed: (
    newsletterContact: NewsletterContactModel,
  ) => void;
}

export default class ContactDetailsInfoComponent extends Component<ComponentArgs> {}
